export const rewindAtValue = (audioPlayerRef, changeRange) => {
	// eslint-disable-next-line no-return-assign
	const handleSetPlayerTime = (value) =>
		// eslint-disable-next-line no-param-reassign
		(audioPlayerRef.current.currentTime += value);

	const changeTime = (timeValue) => {
		handleSetPlayerTime(timeValue);
		changeRange();
	};

	const rewindOnKeyClick = (key) => {
		switch (key) {
			case 'ArrowLeft':
				return changeTime(-15);
			case 'ArrowRight':
				return changeTime(15);
			default:
				return '';
		}
	};

	const rewindTrack = (event, period) => {
		if (event.type === 'click') {
			changeTime(period);
		}
		if (event.key) {
			rewindOnKeyClick(event.key);
		}
	};

	return (period) => (event) => rewindTrack(event, period);
};
